<a href="{{imageSrc}}" data-lightbox="lightbox">
  <img src="{{imageSrc}}" class="{{class}}">
</a>
